export const BACKGROUND_MUSIC_FADE_OUT_DURATION_MS = 3_000;
export const IS_SLOT_MACHINE_BACKGROUND_MUSIC_AVAILABLE = false;
